export function getOrderItemsCount() {
  var order = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (!order) {
    return 0;
  }
  var _order$line_items = order.line_items,
    lineItems = _order$line_items === void 0 ? [] : _order$line_items;
  return lineItems.length;
}
export function isOrderClosed() {
  var order = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _order$status = order.status,
    status = _order$status === void 0 ? '' : _order$status;
  return status.toLowerCase() === 'closed';
}
export function getOrderSubtotal() {
  var order = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref = order || {},
    _ref$sub_total = _ref.sub_total,
    subTotal = _ref$sub_total === void 0 ? 0 : _ref$sub_total;
  return +(subTotal || 0);
}
export function isTakeoutOrder() {
  var order = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _order$fulfillment_ty = order.fulfillment_type,
    fulfillmentType = _order$fulfillment_ty === void 0 ? '' : _order$fulfillment_ty;
  return fulfillmentType === 'INSTORE';
}
export function getOrderItemsCountDisplay() {
  var order = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var itemsCount = getOrderItemsCount(order);
  return itemsCount === 1 ? "".concat(itemsCount, " item") : "".concat(itemsCount, " items");
}